import { createAppointmentApi as generatedCreateAppointmentApi } from '../generated/appointments/createAppointment';

const createAppointmentApi = generatedCreateAppointmentApi.enhanceEndpoints({
  endpoints: {
    createAppointment: {
      invalidatesTags: [
        { id: 'UPCOMING', type: 'UpcomingAll' as const },
        { id: 'UPCOMING', type: 'UpcomingAppointment' as const },
        { id: 'UPCOMING', type: 'UpcomingDraft' as const },
        { type: 'Clients' as const },
        { type: 'Schedule' as const },
      ],
    },
  },
});

export { createAppointmentApi };
